import React from 'react'
import './ExitModal.css'

interface ExitModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ExitModal: React.FC<ExitModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null

  return (
    <div className="exit-modal-overlay">
      <div className="exit-modal">
        <p className="exit-modal-text">
          Your guided exercise is still playing, are you sure you want to quit now?
        </p>
        <div className="exit-modal-button-container">
          <button onClick={onConfirm} className="exit-modal-button">
            Yes
          </button>
          <button onClick={onCancel} className="exit-modal-button">
            No
          </button>
        </div>
      </div>
    </div>
  )
}

export default ExitModal
